import { EventStatus } from '@wix/events-types';
export const UPCOMING_EVENT_STATUSES = [EventStatus.SCHEDULED, EventStatus.STARTED];
export const PAST_EVENT_STATUSES = [EventStatus.ENDED, EventStatus.CANCELED];
export const WIX_FEE_RATE = 0.025;
export const THANK_YOU_MESSAGES_DYNAMIC_GUEST_NAME_PLACEHOLDER = '{Guest Name}';
export const THANK_YOU_MESSAGES_DYNAMIC_EVENT_NAME_PLACEHOLDER = '{Event Name}';
export const THANK_YOU_MESSAGES_DYNAMIC_GUEST_EMAIL_PLACEHOLDER = '{Guest Email}';
//# sourceMappingURL=event.js.map